
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
import { CustomerArticleDto } from "@/dtos/customerArticleDto";
import { ArticleState } from "@/dtos/articleState";
import { HintId } from "@/dtos/hintId";
import { PriceListDto } from "@/dtos/priceListDto";
import PriceModelDefault, { PriceModel } from "@/dtos/priceModel";
import { PriceDto } from "@/dtos/priceDto";
import SpeechBubbleFloat from "@/views/Dialogs/SpeechBubbleFloat.vue";
import ArticlePriceInfoDialog from "@/views/Dialogs/ArticlePriceInfoDialog.vue";

@Component({
	components: {
		SpeechBubbleFloat,
		ArticlePriceInfoDialog,
	},
})
export default class ArticleTilePricelist extends Vue {
	@Prop()
	private article!: CustomerArticleDto;
	@Prop()
	private isAssembly!: boolean;
	@Prop()
	private isAssemblyView!: boolean;
	private isLoadingPrices: boolean = false;
	private pricesValid: boolean = true;
	private priceModels = PriceModelDefault.allPriceModels;
	private preisInformationenDialog: boolean = false;
	private priceListHintTitle = "Den finalen Preis inkl. Mengenrabatt sehen Sie im Warenkorb.";
	private priceListHintText =
		"Mehrere Artikel mit gleichen Bearbeitungen oder gleichem Material " +
		"führen zu einem Preisnachlass. Um den definitiven Preis zu kalkulieren, " +
		"stellen Sie bitte einen Warenkorb zusammen und lassen Sie sich innert Sekunden ein Angebot " +
		"inkl. Liefertermin berechnen.";

	private async loadPrices() {
		if (this.article.priceLists && this.article.priceLists.length >= 1) {
			return;
		}
		try {
			this.isLoadingPrices = true;
			const response = await httpClient().get(
				`Article/LoadPrices?articleId=${this.article.articleId}`
			);
			if (response.data.length <= 0) {
				throw new Error();
			} else {
				this.$store.commit("addOrUpdateArticlePricelists", response.data);
			}
		} catch (ex) {
			this.pricesValid = false;
			console.log(`Could not load prices for article ${this.article.articleId}`);
			this.$store.dispatch(
				"setSnackbarErrorText",
				"Preise für Artikel konnten nicht geladen werden."
			);
		} finally {
			this.isLoadingPrices = false;
		}
	}

	private get subArticles(): CustomerArticleDto[] {
		if (!this.isAssembly) return [];
		const subArticles = this.$store.state.articles.filter(
			(a: CustomerArticleDto) => a.parentArticleId == this.article.articleId
		);
		return subArticles;
	}

	private get showPriceList(): boolean {
		if (this.article.calculating || this.article.migrated || this.article.locked) {
			return false;
		}
		if (this.article.isAssembly) {
			if (
				this.subArticles.some((sa: CustomerArticleDto) => sa.calculating) ||
				this.subArticles.some(
					(sa: CustomerArticleDto) =>
						sa.state != ArticleState.OK && sa.state != ArticleState.Warning
				) ||
				this.subArticles.some((sa: CustomerArticleDto) => sa.migrated) ||
				this.subArticles.some((sa: CustomerArticleDto) => sa.locked)
			) {
				return false;
			}
		} else {
			if (
				this.article.state !== ArticleState.OK &&
				this.article.state !== ArticleState.Warning
			) {
				return false;
			}
		}

		return true;
	}

	private get waehrung() {
		return this.$store.getters.waehrung;
	}

	private get priceStateColor() {
		return this.pricesValid ? "white" : "#FFCDD2";
	}

	private get isCalculating() {
		if (this.isAssembly) {
			return (
				this.article.calculating ||
				this.subArticles.some((sa: CustomerArticleDto) => sa.calculating)
			);
		} else {
			return this.article.calculating;
		}
	}

	private get priceListHintId(): number {
		return HintId.ShopPriceList;
	}

	private get availablePriceModels() {
		if (!this.article.priceLists) return [];
		let availablePriceModels = this.priceModels.filter((p: any) =>
			this.article.priceLists.some((pl: PriceListDto) => pl.priceModel == p.value)
		);
		return availablePriceModels;
	}

	private get sortedPrices() {
		if (!this.article.priceLists || this.article.priceLists.length <= 0) {
			return [];
		} else {
			let sortedPrices: PriceDto[] = Array.from(this.article.priceLists[0].prices);
			return sortedPrices.sort((a: any, b: any) => a.quantity - b.quantity);
		}
	}

	private getModelPrice(quantity: number, model: PriceModel): string {
		if (!this.article.priceLists) return "";
		let list = this.article.priceLists.filter((pl: PriceListDto) => pl.priceModel == model)[0];
		return list.prices.filter((p: PriceDto) => p.quantity === quantity)[0].price.toFixed(2);
	}

	private addToCart(quantity: number) {
		this.$emit("addToCart", quantity);
	}
}
